import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {TagList} from '@/components/tags-manager-dialog'
import {SectionCard} from '@/components/section-card'
import {SegmentedControl} from '@/components/segmented-control'
import type {TagKind} from '@/hooks/empresa/organizacion/use-tags'

const KINDS: TagKind[] = ['positions', 'areas']

export function AreasSection({businessId, canEdit}: {businessId: string; canEdit: boolean}) {
  const {t} = useTranslation()
  const [kind, setKind] = useState<TagKind>('positions')

  return (
    <SectionCard
      testId="perfil-areas-section"
      title={t('business.areasTab.title')}
      actions={
        <SegmentedControl
          value={kind}
          onChange={setKind}
          options={KINDS.map((k) => ({key: k, label: t(`tags.kind.${k}`), testId: `perfil-areas-kind-${k}`}))}
        />
      }>
      <TagList key={kind} businessId={businessId} kind={kind} open canEdit={canEdit} />
    </SectionCard>
  )
}
